// extracted by mini-css-extract-plugin
export default {"watermark":"styles_watermark__UXaX2","topText":"styles_topText__AsiNB","bottomText":"styles_bottomText__FGBtD"};